import { render, staticRenderFns } from "./AllSkusTab.vue?vue&type=template&id=e60228b6&scoped=true"
import script from "./AllSkusTab.vue?vue&type=script&lang=ts"
export * from "./AllSkusTab.vue?vue&type=script&lang=ts"
import style0 from "./AllSkusTab.vue?vue&type=style&index=0&id=e60228b6&prod&scoped=true&lang=css"
import style1 from "./AllSkusTab.vue?vue&type=style&index=1&id=e60228b6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e60228b6",
  null
  
)

export default component.exports